import { Link } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import { useState, useEffect, useRef } from 'react'
import { ROUTES, APP_CONFIG } from '../config/constants'

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const navRef = useRef(null)

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') setMobileMenuOpen(false)
    }
    document.addEventListener('keydown', handleEscape)
    return () => document.removeEventListener('keydown', handleEscape)
  }, [])

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (mobileMenuOpen && navRef.current && !navRef.current.contains(e.target)) {
        setMobileMenuOpen(false)
      }
    }
    document.addEventListener('click', handleClickOutside)
    return () => document.removeEventListener('click', handleClickOutside)
  }, [mobileMenuOpen])

  return (
    <motion.nav 
      ref={navRef}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className="fixed top-0 w-full z-50 bg-stadium-black/80 backdrop-blur-md border-b border-pitch-green/20"
    >
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <Link to={ROUTES.HOME} className="text-xl md:text-2xl font-bold text-pitch-green text-glow">
          {APP_CONFIG.NAME.toUpperCase()}
        </Link>
        
        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-8">
          <Link to={ROUTES.HOME} className="hover:text-pitch-green transition-colors">Home</Link>
          <Link to={ROUTES.PRICING} className="hover:text-pitch-green transition-colors">Pricing</Link>
          <Link to={ROUTES.DOWNLOAD} className="hover:text-pitch-green transition-colors">Download App</Link>
          <a 
            href="https://www.instagram.com/reelcricket.in/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="hover:text-pitch-green transition-colors flex items-center gap-1 text-pink-400 hover:text-pink-300 font-semibold"
          >
            Instagram Reels ↗
          </a>
          <Link 
            to={ROUTES.UPLOAD} 
            className="bg-pitch-green text-stadium-black px-6 py-2 rounded-full font-bold hover:bg-neon-green transition-all"
          >
            Upload Match
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden text-pitch-green p-2"
          aria-label="Toggle menu"
          aria-expanded={mobileMenuOpen}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {mobileMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden border-t border-pitch-green/20 bg-stadium-black/95 backdrop-blur-md"
          >
            <div className="container mx-auto px-4 py-4 flex flex-col gap-4">
              <Link 
                to={ROUTES.HOME} 
                onClick={() => setMobileMenuOpen(false)}
                className="hover:text-pitch-green transition-colors py-2"
              >
                Home
              </Link>
              <Link 
                to={ROUTES.PRICING} 
                onClick={() => setMobileMenuOpen(false)}
                className="hover:text-pitch-green transition-colors py-2"
              >
                Pricing
              </Link>
              <Link 
                to={ROUTES.DOWNLOAD} 
                onClick={() => setMobileMenuOpen(false)}
                className="hover:text-pitch-green transition-colors py-2"
              >
                Download App
              </Link>
              <a 
                href="https://www.instagram.com/reelcricket.in/" 
                target="_blank" 
                rel="noopener noreferrer" 
                onClick={() => setMobileMenuOpen(false)}
                className="hover:text-pitch-green transition-colors py-2 text-pink-400 flex items-center gap-1 font-semibold"
              >
                Instagram Reels ↗
              </a>
              <Link 
                to={ROUTES.UPLOAD} 
                onClick={() => setMobileMenuOpen(false)}
                className="bg-pitch-green text-stadium-black px-6 py-2 rounded-full font-bold hover:bg-neon-green transition-all text-center"
              >
                Upload Match
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  )
}
